import { render, staticRenderFns } from "./PuntosDeVentaInicio.vue?vue&type=template&id=8305c3a2"
import script from "./PuntosDeVentaInicio.vue?vue&type=script&lang=js"
export * from "./PuntosDeVentaInicio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports